import { takeEvery } from 'redux-saga/effects'

import { FEED_UPDATE_REACTION, FEED_SET_REACTION } from 'store/entities/feed/actionTypes'
import { showError } from 'store/entities/toastr/utils'
import { CREATE_REACTION_EVENT, UPDATE_REACTION_EVENT } from 'app/constants/reactions'

export default function* getReactionSaga(params) {
  yield* [
    takeEvery(FEED_SET_REACTION, handleSetReaction, params),
    takeEvery(FEED_UPDATE_REACTION, handleUpdateReaction, params),
  ]
}

export function handleSetReaction(params, { payload }) {
  try {
    params.socket.emit(CREATE_REACTION_EVENT, payload)
  } catch (badResponse) {
    showError()
  }
}

export function handleUpdateReaction(params, { payload }) {
  const { reaction, emoji } = payload
  try {
    params.socket.emit(UPDATE_REACTION_EVENT, {
      reactionId: reaction.id,
      emoji,
    })
  } catch (badResponse) {
    showError()
  }
}
